// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n.z-backtop {\n  background: transparent;\n  box-shadow: none;\n  z-index: 1000;\n}", ""]);
// Exports
module.exports = exports;
